import { Box } from '@mui/material';
import { CountryItem } from 'src/components/country-bar/types';
import { EXPLORE_COLORS } from './constants';

/**
 * Libellé d'un onglet de la CountryBar (Explore + Funnel).
 * - Option agrégée ("__all__") => "All" (pas de drapeau).
 * - Pays => code en majuscules seul. La couverture % (`share_of_brand_searches`)
 *   n'est plus affichée mais reste portée par la donnée : `useCountryData` s'en
 *   sert pour trier les onglets par couverture desc.
 * - `isSelected` (défaut true) : onglet actif = code sombre (valueDark) ;
 *   onglet inactif = grisé (#919EAB) comme sur le Funnel.
 */
export function CountryTabLabel({
  country,
  isSelected = true,
}: {
  country: CountryItem;
  isSelected?: boolean;
}) {
  const codeColor = isSelected ? EXPLORE_COLORS.valueDark : EXPLORE_COLORS.textDisabled;

  if (country.country_code === '__all__') {
    return (
      <Box component="span" sx={{ color: codeColor }}>
        All
      </Box>
    );
  }

  return (
    <Box component="span" sx={{ color: codeColor }}>
      {(country.country_code ?? '').toUpperCase()}
    </Box>
  );
}
